document.querySelectorAll('.childmenu-image-container').forEach(container => {
  const subMenu = container.querySelector('.sub-menu-container');
  if (!subMenu) return;

  let hideTimeout;

  const show = () => {
    clearTimeout(hideTimeout);
    subMenu.classList.add('active');
  };

  const hide = () => {
    hideTimeout = setTimeout(() => {
      subMenu.classList.remove('active');
    }, 100);
  };

  container.addEventListener('mouseenter', show);
  container.addEventListener('mouseleave', hide);
  subMenu.addEventListener('mouseenter', show);
  subMenu.addEventListener('mouseleave', hide);
});


document.querySelectorAll('.mobile-nav-child-sub-menu').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const container = trigger.closest('.mobile-nav-child-container');
    const subMenu = container.querySelector('.sub-menu-container');
    const icon = trigger.querySelector('.mobile-nav__link-icon');

    const isOpen = subMenu.classList.contains('active');

    subMenu.classList.toggle('active', !isOpen);
    icon.classList.toggle('rotated', !isOpen);
  });
});


const tabContainer = document.querySelector(".tab-images-tab-heading-block");
const tabHeading = document.querySelectorAll(".tab-images-tab-heading");
const tabBlock = document.querySelectorAll(".tab-images-block");

tabContainer.addEventListener("click", function(e){
  const clicked = e.target.closest(".tab-images-tab-heading");
  if (!clicked) return null;
  tabHeading.forEach( th => th.classList.remove('tab-images-tab-heading--active') );
  clicked.classList.add("tab-images-tab-heading--active");
  tabBlock.forEach( th => th.classList.remove('tab-images-block--active') );
  document.querySelector(`.tab-images-block--${ clicked.dataset.tab }`).classList.add("tab-images-block--active");
});

const modal = document.getElementsByClassName('idMyModal');
const img = document.getElementsByClassName('toZoom');
const modalImg = document.getElementsByClassName('modal-content');
for ( let i = 0; i < img.length; i++ ) {
  img[i].onclick = function () {
    modal[i].style.display = "block";
    modalImg[i].src = this.dataset.src;
  }
}

var span = document.getElementsByClassName("close");
for ( let i = 0; i < span.length; i++ ) {
  span[i].onclick = function() { 
    modal[i].style.display = "none";
  }
}